import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedSettingsService } from '../../services/rheological.service';

@Component({
  selector: 'app-setup',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.css']
})
export class SetupComponent implements OnInit {
  casingOD: number = 9.625;
  holeDiameter: number = 12.250;

  constructor(private sharedSettingsService: SharedSettingsService) {}

  ngOnInit(): void {
    // Initialize service with defaults
    this.syncToService();
  }

  onValueChange(): void {
    this.syncToService();
  }

  private syncToService(): void {
    this.sharedSettingsService.setSharedSetting({
      casingOD: this.casingOD,
      holeDiameter: this.holeDiameter
    });
  }

  hasValue(value: number | null): boolean {
    return value !== null && value !== undefined && value !== 0 && value.toString() !== '';
  }
}